var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 11V13H22.375V11H18.375ZM16.375 17.61C17.335 18.32 18.585 19.26 19.575 20C19.975 19.47 20.375 18.93 20.775 18.4C19.785 17.66 18.535 16.72 17.575 16C17.175 16.54 16.775 17.08 16.375 17.61ZM20.775 5.6C20.375 5.07 19.975 4.53 19.575 4C18.585 4.74 17.335 5.68 16.375 6.4C16.775 6.93 17.175 7.47 17.575 8C18.535 7.28 19.785 6.35 20.775 5.6ZM4.375 9C3.275 9 2.375 9.9 2.375 11V13C2.375 14.1 3.275 15 4.375 15H5.375V19H7.375V15H8.375L13.375 18V6L8.375 9H4.375ZM15.875 12C15.875 10.67 15.295 9.47 14.375 8.65V15.34C15.295 14.53 15.875 13.33 15.875 12Z",
    fill: "#AFBAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.9951c958984f3b1d4d93bec025b8b849.svg";
export { ForwardRef as ReactComponent };